// utils/topicIconMap.js
const TOPIC_ICON_MAP = {
  // Math - Numbers & Arithmetic
  integers: '➕',
  'rational numbers': '½',
  fractions: '🥧',
  decimals: '🎯',
  algebra: '🔣',
  geometry: '📐',
  percentage: '％',
  star: '⭐',
  rocket: '🚀',
  numbers: '🔢',
  number: '🔢',
  alphabets: '🔤',
  subtraction: '➖',
  addition: '➕',
  
  // Math - Multiplication Tables (catch pattern "tables")
  tables: '✖️',
  
  // English / Grammar
  nouns: '🏷️',
  verbs: '🏃',
  adjectives: '🎨',
  tenses: '⏳',
  punctuation: '❓',
  vocabulary: '📖',

  // Science - Biology / Human Body
  'digestive system': '🥪',
  circulatory: '🫀',
  respiratory: '🫁',
  skeletal: '🦴',
  plants: '🌱',
  cells: '🔬',
  food: '🍎',
  body: '🧍',
  worship: '🛐',
  clothes: '👕',
  pollution: '💨',
  shelter: '🏠',
  computer: '💻',
  computers: '💻',
  keyboard: '⌨️',
  world: '🌍',
  flags: '🏳️',
  person: '🧑',
  capitals: '🏛️',
  astronomy: '🔭',
  clocks: '⏰',

  // Science - Physics & Chemistry
  forces: '🧲',
  light: '💡',
  matter: '⚗️',
  periodic: '🧪',
  science: '🔬',
  
  // General
  cartoon: '🏂',
  hero: '🦸',
  gaming: '🎮',
};

export const resolveTopicIcon = (topic, subjectName = '') => {
  // 2. Fuzzy match against topic name keywords
  const nameLower = (topic.name || '').toLowerCase();
  
  for (const [key, icon] of Object.entries(TOPIC_ICON_MAP)) {
    if (nameLower.includes(key)) {
      return icon;
    }
  }

  // Special match for multiplication tables (e.g., "Tables 2 & 3")
  if (nameLower.includes('table') || nameLower.includes('multiplication')) {
    return '✖️';
  }

  // 3. Subject-level fallback
  const subjectLower = subjectName.toLowerCase();
  if (subjectLower.includes('math')) return '📐';
  if (subjectLower.includes('science')) return '🔬';
  if (subjectLower.includes('english') || subjectLower.includes('language')) return '📚';

  return '🎯';
};